import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/components/toast/toast.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { UploadProgressToastComponent } from './shared/components/upload-progress-toast/upload-progress-toast.component';
import { AuthService } from './core/auth/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent, LoaderComponent, UploadProgressToastComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  private auth = inject(AuthService);

  ngOnInit(): void {
    if (this.auth.isAuthenticated()) {
      this.auth.scheduleProactiveRefresh();
      // Restore the in-memory currentUser signal after a page reload.
      // Without this, canManage() / canManageRelease() etc. stay false
      // until the shell's ngOnInit fires its own loadCurrentUser() call,
      // creating a race condition where dropdowns open before the user
      // object arrives and permanently show "View only" / hide actions.
      if (!this.auth.currentUser()) {
        this.auth.loadCurrentUser().subscribe({ error: () => {} });
      }
    }
  }
}
